<template lang="pug">
span
  field-row(:columns="row.columns")
    template(
      v-for="(sub, i) in row.fields",
      :key="sub.id || sub.type + '-' + i"
    )
      slot(name="default", :is="sub.type.toLowerCase()", :sub="sub" ref="item")
</template>

  <script>
  import {reactive} from "vue";
  
  export default {
    name: "Row",
    props: {
      field: Object,
    },
    setup(p) {
      const row = reactive(initRow());  
      return {row};
  
      function initRow() {
        const fields = p.field.fields;
        const columns = p.field.columns;
        return {
          fields,
          columns
        };
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  span {
    display: contents;
  }
  </style>
  